import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "container-tiles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, {
    class: "container-widget",
    widthType: _ctx.WidthType.third
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        title: _ctx.widget.libelle,
        subtitle: _ctx.$t('outPreventiveWidget.subtitle'),
        iconUrl: _ctx.loadIcon,
        "mode-edition": true,
        onFiltre: _ctx.filtre,
        onDupliquer: _ctx.dupliquer,
        onSuppression: _ctx.suppression
      }, null, 8, ["title", "subtitle", "iconUrl", "onFiltre", "onDupliquer", "onSuppression"]),
      _createElementVNode("div", null, [
        (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('multisites')), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
              return (_openBlock(), _createElementBlock("span", {
                key: site.id,
                class: "site-widget"
              }, [
                _createTextVNode(_toDisplayString(site.description) + " ", 1),
                (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Tile, {
          class: "tile",
          value: 5,
          color: "--edition-clair",
          titleNotBold: _ctx.$tc('outPreventiveWidget.intervention', _ctx.getPreventiveOutData.nbARealiser),
          titleInBold: _ctx.$t('outPreventiveWidget.nbARealiser'),
          isLoading: false
        }, null, 8, ["titleNotBold", "titleInBold"]),
        _createVNode(_component_Tile, {
          class: "tile",
          value: 3,
          color: "--edition-medium",
          titleNotBold: _ctx.$tc('outPreventiveWidget.intervention', _ctx.getPreventiveOutData.nbEnCours),
          titleInBold: _ctx.$t('outPreventiveWidget.nbEnCours'),
          isLoading: false
        }, null, 8, ["titleNotBold", "titleInBold"]),
        _createVNode(_component_Tile, {
          class: "tile",
          value: 5,
          color: "--edition-fonce",
          titleNotBold: _ctx.$tc('outPreventiveWidget.intervention', _ctx.getPreventiveOutData.nbRealisees),
          titleInBold: _ctx.$tc('outPreventiveWidget.nbRealisees', _ctx.getPreventiveOutData.nbRealisees),
          isLoading: false
        }, null, 8, ["titleNotBold", "titleInBold"])
      ])
    ]),
    _: 1
  }, 8, ["widthType"]))
}